import { render } from "./LeaveManage.vue?vue&type=template&id=bb2ddd7e"
import script from "./LeaveManage.vue?vue&type=script&lang=js"
export * from "./LeaveManage.vue?vue&type=script&lang=js"

import "./LeaveManage.vue?vue&type=style&index=0&id=bb2ddd7e&lang=less"

import exportComponent from "D:\\VueProject\\ekk-hrm-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__